<template>
  <div class="content gdoc" :class="classname" >
    <div v-if="!showIframe" @click.stop.prevent="showIframe = true"
         class="thumbnail"
         :style="{ backgroundImage:'url('+img+')' }" >
    </div>
    <!-- <div v-if="!showIframe" @click.stop.prevent="showIframe = true" class="thumbnail" :style="backgroundStyles"></div> -->
    <div v-if="showIframe" class="iframe-wrapper">
      <!-- :style="{paddingBottom:presentation}" -->
      <iframe :src="'https://drive.google.com/file/d/' + gFile.id + '/preview'"></iframe>
    </div>
  </div>
</template>
<script>
export default {
  name: 'GFileDoc',
  props: {
    gFile: Object,
    gBaseUrl: String
  },
  data () {
    return {
      showIframe: false,
      img: this.gBaseUrl + '/thumbnail?export=view&sz=w1140&id=' + this.gFile.id
    }
  },
  computed: {
    classname () {
      switch (this.gFile.mimeType) {
        case 'application/vnd.google-apps.presentation':
          return 'presentation'
        case 'application/pdf':
          return 'pdf'
        case 'application/vnd.google-apps.document':
          return 'document'
        case 'application/vnd.google-apps.spreadsheet':
          return 'spreadsheet'
        default:
          return 'doc'
      }
    }
  }
}
</script>
